import { useIslandsTVL, useUserTotalBalance } from 'hooks/backend/islands'
import { useConnection } from 'hooks/useConnection'
import { useContext } from 'react'
import { useKodiakIslandTotalUserDeposit } from 'state/userPositionData/hooks'
import styled, { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'
import { formatDollarAmount } from 'utils/formatDollarAmt'

import * as S from '../Liquidity.styles'

export const MobileLimitedHeaderTitle = styled(S.HeaderTitleFlex)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 160px;
  `};
`

export default function IslandHeader() {
  const { account } = useConnection()
  const userTotalDeposits = useKodiakIslandTotalUserDeposit()
  const theme = useContext(ThemeContext)

  const { data: totalValueLockedUSD } = useIslandsTVL()
  const { data: totalUserBalance } = useUserTotalBalance(account ?? '')

  return (
    <S.Header>
      <MobileLimitedHeaderTitle>
        <ThemedText.DeprecatedBody fontSize="18px" fontWeight="700">
          Markets
        </ThemedText.DeprecatedBody>

        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" color={theme.textSecondary}>
          Deposit in the top Kodiak Islands and V2 pools.
        </ThemedText.DeprecatedBody>
      </MobileLimitedHeaderTitle>
      <S.HeaderBoxFlex>
        <S.HeaderBox>
          <ThemedText.DeprecatedBody
            fontSize="14px"
            fontWeight="500"
            color={theme.textSecondary}
            lineHeight="14px"
            style={{ whiteSpace: 'nowrap' }}
          >
            Top Pools TVL
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            {formatDollarAmount(totalValueLockedUSD) || '$0.00'}
          </ThemedText.DeprecatedBody>
        </S.HeaderBox>

        <S.HeaderBoxDesktop>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" color={theme.textSecondary} lineHeight="14px">
            My Deposits
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            {formatDollarAmount(totalUserBalance) || '$0.00'}
          </ThemedText.DeprecatedBody>
        </S.HeaderBoxDesktop>
      </S.HeaderBoxFlex>
    </S.Header>
  )
}
// ) : filteredPositions && closedPositions && tempIslandDetails.length > 0 ? (
